import React from 'react';

const Error = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
  >
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g transform="translate(-695 -706) translate(519 674) translate(176 32)">
            <rect width="52" height="52" fill="#FA5454" rx="26" />
            <rect
              width="28"
              height="28"
              x="12"
              y="12"
              fill="#FA5454"
              stroke="#FFF"
              strokeWidth="2"
              rx="14"
            />
            <g stroke="#FFF" strokeLinecap="round" strokeWidth="2">
              <path d="M0 0L9.183 9.183" transform="translate(21 21)" />
              <path
                d="M0 0L9.183 9.183"
                transform="translate(21 21) matrix(-1 0 0 1 9.183 0)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Error;
